'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reduxFormPropFilter = require('../../helpers/reduxFormPropFilter');

var _reduxFormPropFilter2 = _interopRequireDefault(_reduxFormPropFilter);

var _onChangeHookGenerator = require('../../helpers/onChangeHookGenerator');

var _onChangeHookGenerator2 = _interopRequireDefault(_onChangeHookGenerator);

var _translate = require('../../../v2/language/translate');

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a single radio input.
 * @extends {Component}
 */
var RadioComponent = function (_React$Component) {
  _inherits(RadioComponent, _React$Component);

  function RadioComponent() {
    _classCallCheck(this, RadioComponent);

    return _possibleConstructorReturn(this, (RadioComponent.__proto__ || Object.getPrototypeOf(RadioComponent)).apply(this, arguments));
  }

  _createClass(RadioComponent, [{
    key: 'render',
    value: function render() {
      var tugoClass = this.props.tugoMq ? 'hide-radio-inline' : '';
      return _react2.default.createElement(
        _reactBootstrap.Radio,
        _extends({}, (0, _reduxFormPropFilter2.default)(this.props.field), {
          onChange: (0, _onChangeHookGenerator2.default)(this.props.field.onChange, this.props.onChangeHook),
          className: tugoClass + ' ingle-form-radio',
          inline: this.props.isInline,
          value: this.props.htmlValue,
          checked: this.props.field.value === this.props.htmlValue,
          disabled: this.props.disabled
        }),
        (0, _translate.t)(this.props.htmlText)
      );
    }
  }]);

  return RadioComponent;
}(_react2.default.Component);

RadioComponent.propTypes = {
  field: _react2.default.PropTypes.object.isRequired,
  isInline: _react2.default.PropTypes.bool,
  disabled: _react2.default.PropTypes.bool,
  htmlValue: _react2.default.PropTypes.string.isRequired,
  htmlText: _react2.default.PropTypes.string.isRequired,
  onChangeHook: _react2.default.PropTypes.func,
  tugoMq: _react2.default.PropTypes.bool
};
RadioComponent.defaultProps = {
  isInline: true
};
exports.default = RadioComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/RadioComponent.jsx
// module id = 1673
// module chunks = 0